let QRCode = require('qrcodejs2');

let qrObject;

let inputSelector = '.js-qr-input';
let outputSelector = '.js-qr-output';

let text = app.url.getCurParam('s');
if (text) {
    $(inputSelector).val(text);
}

drawQr();
$(document).on('keyup', '.js-qr-input', drawQr);
$('.js-qr-input').focus();

function drawQr() {
    let text = $(inputSelector).val() || '';
    let $output = $(outputSelector);

    if (qrObject === undefined || !$output.find('img').length) {
        qrObject = new QRCode($output[0], {
            width: 256,
            height: 256,
            useSVG: true
        });
    } else {
        qrObject.clear();
    }

    qrObject.makeCode(text);

    app.url.setCurParam('s', text);
}
